/**
 * @generated SignedSource<<f7eecc5a891f222b20607cdcecc50c82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type reviewPage_GenerateAiSuggestionsMutation$variables = Record<PropertyKey, never>;
export type reviewPage_GenerateAiSuggestionsMutation$data = {
  readonly generateAiSuggestions: {
    readonly enqueued: boolean;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type reviewPage_GenerateAiSuggestionsMutation = {
  response: reviewPage_GenerateAiSuggestionsMutation$data;
  variables: reviewPage_GenerateAiSuggestionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enqueued",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "reviewPage_GenerateAiSuggestionsMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GenerateAiSuggestionsMutationPayload",
        "kind": "LinkedField",
        "name": "generateAiSuggestions",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "reviewPage_GenerateAiSuggestionsMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GenerateAiSuggestionsMutationPayload",
        "kind": "LinkedField",
        "name": "generateAiSuggestions",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "41c92dc200365057e4c921eff65349e5",
    "id": null,
    "metadata": {},
    "name": "reviewPage_GenerateAiSuggestionsMutation",
    "operationKind": "mutation",
    "text": "mutation reviewPage_GenerateAiSuggestionsMutation {\n  generateAiSuggestions {\n    enqueued\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1638c61c7bb9879ed46afeeb13dab818";

export default node;
